import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DatasharesIntegrationCreateForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatasharesIntegrationCreateForNro").then((module) => ({
    default: module.DatasharesIntegrationCreateForNro,
  }))
);

export const datasharesIntegrationCreateNRO: NavigationRoutingObject = {
  Component: DatasharesIntegrationCreateForNro,
  // eslint-disable-next-line local-eslint-rules/enforce-nro-component-feature-flipper-use
  componentFeatureFlippers: ["datashares_integrations", "datashares_integration_nro_component"],
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("datashares-create-tab-snowflake-heading", "Create Snowflake Datashare"),
  pageNameForTracking: () => "Create Snowflake Datashare",
  icon: "nav-system-data-sharing",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("datashares_integrations");
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
